<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
  >
    <folder-transfer-dialog
      :employee="employee"
      ref="folderTransfer"
    />

    <v-card >
      <v-card-title class="docgo white--text title">
        <v-icon class="pr-4" color="white">
          mdi-account-multiple-plus
        </v-icon>
        <span>
          {{dialogTitle}}
        </span>
      </v-card-title>

      <v-layout>
        <v-tabs v-model="defaultTab" class="pa-2 pr-4" style="width: 100%">
          <v-tab
            class="ml-2"
            v-for="tab in tabs"
            :key="tab.key"
            :href="`#${tab.key}`"
          >
            {{ tab.name }}

          </v-tab>

          <v-spacer></v-spacer>

          <router-link :to="{name: 'EmployeeFolder', params: {id: employee.id}}">
            <v-btn outline>Ver processos</v-btn>
          </router-link>

          <v-tooltip left color="blue lighten-5" max-width="250">
            <template v-slot:activator="{ on }">
              <v-icon color="docgo" v-on="on">
                mdi-help-circle
              </v-icon>
            </template>
            <v-layout class="py-1 px-2">
              <span class="docgo--text">
                É necessário preencher todos os dados para criar um novo funcionário.
              </span>
            </v-layout>
          </v-tooltip>



          <v-tab-item key="conta" value="conta" class="mt-2">
            <v-form ref="contaTab" v-model="contaTab" lazy-validation>
              <v-layout>
                <v-flex xs3 class="mr-4">
                  <v-layout column align-center justify-center>
                    <v-layout>
                      <v-avatar size="105" >
                        <v-img
                          :src="imageUrl"
                        />
                      </v-avatar>
                    </v-layout>
                    <v-btn color="docgo" dark flat>
                      <v-icon class="pr-2">mdi-camera</v-icon>
                      Enviar Foto
                      <input
                        id="uploader"
                        class="white custom-uploader"
                        type="file"
                        @change="uploadFile"
                        accept=".jpg, .png"
                      />
                    </v-btn>
                  </v-layout>
                </v-flex>

                <v-flex>
                  <span class="subheading font-weight-bold grey--text text--darken-1">Informações</span>
                  <v-layout>
                    <v-flex xs7>
                      <v-text-field
                        label="Nome Completo"
                        persistent-hint
                        v-model="employee.name"
                        :rules="[validationRules.required]"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex>
                      <v-text-field
                        label="Usuário"
                        pesistent-hint
                        v-model="employee.username"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        label="CPF"
                        persistent-hint
                        v-model="employee.cpf"
                        :rules="[validationRules.required,validationRules.cpf]"
                        :mask="masks.cpf"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs3>
                      <v-text-field
                        label="RG"
                        pesistent-hint
                        v-model="employee.rg"
                        :rules="[validationRules.required]"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2>
                      <v-select
                        label="Sexo"
                        v-model="employee.gender"
                        :items="genders"
                        :rules="[validationRules.required]"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs3>
                      <v-select
                        label="Estado Civil"
                        v-model="employee.marital_status"
                        :items="civilStatuses"
                        :rules="[validationRules.required]"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout class="pl-3">
                <v-menu
                  ref="menuBirthDate"
                  v-model="menuBirthDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-flex xs3>
                      <v-text-field
                        v-model="birthDateFormatted"
                        label="Nascimento"
                        append-icon="event"
                        readonly
                        @blur="birthDate = parseDate(birthDateFormatted)"
                        v-on="on"
                        :rules="[validationRules.required]"
                      ></v-text-field>
                    </v-flex>

                  </template>
                  <v-date-picker
                    color="docgo"
                    ref="birthDatePicker"
                    v-model="birthDate"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @change="saveBirthDate"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
                <v-spacer/>
                <v-flex xs4>
                  <v-text-field
                    label="Email"
                    pesistent-hint
                    v-model="employee.email"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
                <v-spacer/>
                <v-flex xs4>
                  <v-select
                    label="Escolaridade"
                    v-model="employee.schooling"
                    :items="schools"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
              </v-layout>
              <v-layout class="pl-3">
                <v-flex xs2>
                  <v-layout column align-center justify-center>
                    <span class="caption"> Administrador </span>
                    <v-layout align-top justify-center>
                      <v-switch
                        class="ma-0"
                        v-model="employee.super_admin"
                      ></v-switch>
                      <span class="pt-1">
                        {{employee.super_admin ? 'Sim' : 'Não'}}
                      </span>
                    </v-layout>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout column align-center justify-center>
                    <span class="caption"> Busca Geral? </span>
                    <v-layout align-top justify-center>
                      <v-switch
                        class="ma-0"
                        v-model="employee.permissions"
                      ></v-switch>
                      <span class="pt-1">
                        {{employee.permissions ? 'Sim' : 'Não'}}
                      </span>
                    </v-layout>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout column align-center justify-center>
                    <span class="caption"> Gera documento final? </span>
                    <v-layout align-top justify-center>
                      <v-switch
                        class="ma-0"
                        v-model="employee.can_generate_final_document"
                      ></v-switch>
                      <span class="pt-1">
                        {{employee.can_generate_final_document ? 'Sim' : 'Não'}}
                      </span>
                    </v-layout>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout column align-center justify-center>
                    <span class="caption"> finaliza processo? </span>
                    <v-layout align-top justify-center>
                      <v-switch
                        class="ma-0"
                        v-model="employee.can_end_process"
                      ></v-switch>
                      <span class="pt-1">
                        {{employee.can_end_process ? 'Sim' : 'Não'}}
                      </span>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-tab-item>

          <v-tab-item key="contato" value="contato" class="mt-2 ml-3">
            <v-form ref="contatoTab" v-model="contatoTab" lazy-validation>
              <v-layout column>
                <v-layout>
                  <v-flex xs2>
                    <v-text-field
                      label="CEP"
                      pesistent-hint
                      @blur="buscarCEP"
                      v-model="employee.address.zipcode"
                      :rules="[validationRules.required]"
                    />
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs8 :key="employee.address.street">
                    <v-text-field
                      label="Rua"
                      pesistent-hint
                      v-model="employee.address.street"
                      :rules="[validationRules.required]"
                    />
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs1>
                    <v-text-field
                      label="N°"
                      pesistent-hint
                      v-model="employee.address.number"
                      :rules="[validationRules.required]"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs7>
                    <v-text-field
                      label="Complemento"
                      pesistent-hint
                      v-model="employee.address.complement"
                    />
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs4>
                    <v-text-field
                      label="Bairro"
                      pesistent-hint
                      v-model="employee.address.neighborhood"
                      :rules="[validationRules.required]"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs4>
                    <!--<v-select-->
                    <!--label="Cidade"-->
                    <!--v-model="employee.address.city"-->
                    <!--:items="cities"-->
                    <!--:rules="[validationRules.required]"-->
                    <!--/>-->
                    <v-text-field
                      label="Cidade"
                      pesistent-hint
                      v-model="employee.address.city"
                      :rules="[validationRules.required]"
                    />
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs1>
                    <v-text-field
                      label="UF"
                      pesistent-hint
                      v-model="employee.address.state"
                      :rules="[validationRules.required]"
                    />
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs3>
                    <v-text-field
                      label="Telefone"
                      pesistent-hint
                      v-model="employee.phone"
                      :mask="masks.phone"
                    />
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs3>
                    <v-text-field
                      label="Celular"
                      pesistent-hint
                      v-model="employee.cellphone"
                      :rules="[validationRules.required]"
                      :mask="masks.cellphone"
                    />
                  </v-flex>
                </v-layout>

              </v-layout>
            </v-form>
          </v-tab-item>

          <v-tab-item key="empresa" value="empresa" class="mt-2 ml-3">
            <v-form ref="empresaTab" v-model="empresaTab" lazy-validation>
              <v-layout column>
                <v-layout row>
                  <v-flex xs2>
                    <v-text-field
                      label="Matrícula"
                      pesistent-hint
                      v-model="employee.registration_number"
                      :rules="[validationRules.required]"
                    />
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs9>
                    <v-autocomplete
                      persistent-hint
                      label="Cargo"
                      v-model="employee.role"
                      :loading="roles.length === 0"
                      :items="roles"
                      item-text="name"
                      :rules="[
                                (value) => {
                                  if (Object.keys(value).length === 0) {
                                    return 'O campo é requerido.';
                                  }
                                  return true;
                                },
                            ]"
                      return-object
                      no-data-text="Nenhum resultado encontrado"
                    />
                  </v-flex>
                  <v-spacer/>
                </v-layout>
                <v-layout row>
                  <v-flex xs6>
                    <v-autocomplete
                      label="Setor Principal"
                      v-model="employee.administrative_unit"
                      :loading="administrativeUnits.length === 0"
                      :items="administrativeUnits"
                      item-text="name"
                      :rules="[
                                (value) => {
                                  if (Object.keys(value).length === 0) {
                                    return 'O campo é requerido.';
                                  }
                                  return true;
                                },
                            ]"
                      return-object
                      no-data-text="Nenhum resultado encontrado"
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <v-select
                      label="Setores Adicionais"
                      v-model="selectedAdministrativeUnitsIds"
                      :loading="administrativeUnits.length === 0"
                      :items="administrativeUnitsFiltered"
                      item-text="name"
                      item-value="id"
                      multiple
                      chips
                      deletable-chips
                      small-chips
                      clearable
                      no-data-text="Nenhum resultado encontrado"
                      :menu-props="{ offsetY: true, maxHeight: 300 }">
                      <template v-slot:selection="{ item, index }">
                        <v-chip small close @input="removeAdminUnit(item)">
                          <span>{{ item.abbreviation || item.name }}</span>
                        </v-chip>
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-menu
                    ref="menuAdmissionDate"
                    v-model="menuAdmissionDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-flex xs2>
                        <v-text-field
                          v-model="admissionDateFormatted"
                          label="Admissão"
                          append-icon="event"
                          readonly
                          @blur="admissionDate = parseDate(admissionDateFormatted)"
                          v-on="on"
                          :rules="[validationRules.required]"
                        ></v-text-field>
                      </v-flex>

                    </template>
                    <v-date-picker
                      color="docgo"
                      ref="admissionDatePicker"
                      v-model="admissionDate"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="saveAdmissionDate"
                      locale="pt-br"
                    ></v-date-picker>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <v-menu
                    ref="menuResignationDate"
                    v-model="menuResignationDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-flex xs3>
                        <v-text-field
                          v-model="resignationDateFormatted"
                          label="Demissão"
                          append-icon="event"
                          readonly
                          clearable
                          @blur="resignationDate = parseDate(resignationDateFormatted)"
                          v-on="on"
                        ></v-text-field>
                      </v-flex>

                    </template>
                    <v-date-picker
                      color="docgo"
                      ref="resignationDatePicker"
                      v-model="resignationDate"
                      :max="new Date().toISOString().substr(0, 10)"
                      :min="minResignationDate"
                      @change="saveResignationDate"
                      locale="pt-br"
                    ></v-date-picker>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <v-flex xs6></v-flex>
                </v-layout>
              </v-layout>
            </v-form>
          </v-tab-item>
        </v-tabs>
      </v-layout>

      <v-card-actions class="px-4 pb-4">
        <v-btn
          flat
          :loading="isSaving"
          @click="closeDialog()"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!!resignationDate"
          color="docgo white--text"
          @click="openFolderTransferDialog"
        >
          Transferir processos
        </v-btn>

        <v-btn
          color="success"
          @click="saveUpdateEmployee()"
          :loading="isSaving"
          :disabled="!contaTab || !empresaTab || !contatoTab"
        >
          <v-icon class="pr-2">
            mdi-content-save
          </v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validationRules from '@/mixins/validation-rules';
import EmployeeService from '@/services/system/EmployeeService';
import FolderTransferDialog from '@/components/folder/entity/FolderTransferDialog';
import masks from '@/mixins/masks';
import adminUnitHandling from '@/mixins/admin-unit-handling';

export default {
  name: "employee-form",
  mixins: [adminUnitHandling],
  props: ['dialog', 'administrativeUnits', 'roles'],
  components: {
    FolderTransferDialog,
  },
  data() {
    return {
      employee: {
        address: {},
        administrative_unit: {},
        administrative_unit_ids: [],
        role: {},
      },
      selectedAdministrativeUnits: [],
      tabs: [
        { name: 'Conta', key: 'conta' },
        { name: 'Endereço e Contato', key: 'contato' },
        { name: 'Empresa', key: 'empresa' },
      ],
      defaultTab: 'conta',
      civilStatuses: [
        'Casado', 'Solteiro',
      ],
      genders: [
        'Masculino', 'Feminino',
      ],
      schools: [
        'Fundamental', 'Médio', 'Superior',
      ],
      cities: [
        'Maceió',
      ],
      imageUrl: '/static/images/settings/new-icons/user.svg',
      file: {},
      birthDate: null,
      birthDateFormatted: null,
      menuBirthDate: false,
      admissionDate: null,
      admissionDateFormatted: null,
      menuAdmissionDate: false,
      resignationDate: null,
      resignationDateFormatted: null,
      menuResignationDate: false,
      validationRules,
      contaTab: true,
      empresaTab: true,
      contatoTab: true,
      isSaving: false,
      masks,
    };
  },
  methods: {
    closeDialog() {
      this.$emit('update:dialog', false);
      this.resetForms();
    },
    buscarCEP() {
      if (this.formatCep()) {
        fetch(`https://viacep.com.br/ws/${this.employee.address.zipcode}/json/`)
          .then(response => response.json())
          .then(data => {
            this.employee.address.neighborhood = data.bairro;
            this.employee.address.city = data.localidade;
            this.employee.address.state = data.uf;
            this.employee.address.street = data.logradouro;
            this.$forceUpdate();
          });
      }
    },
    formatCep() {
      const cepFormatado = this.employee.address.zipcode.replace(/[-.]/g, '');
      if (cepFormatado.length === 8 || cepFormatado.length === 9) {
        this.employee.address.zipcode = cepFormatado;
        return true;
      }
      return false;
    },
    resetForms() {
      this.$refs.contaTab.resetValidation();
      this.$refs.contatoTab.resetValidation();
      this.$refs.empresaTab.resetValidation();
    },
    validateForms() {
      this.$refs.contaTab.validate();
      this.$refs.contatoTab.validate();
      this.$refs.empresaTab.validate();
    },
    saveUpdateEmployee() {
      this.validateForms();
      this.employee.permissions = (this.employee.permissions) ? JSON.stringify({ general_search: true }) : null;
      if (this.$refs.contaTab.validate()
        && this.$refs.contatoTab.validate()
        && this.$refs.empresaTab.validate()) {
        const formData = new FormData();
        formData.append('name', this.employee.name);
        formData.append('cpf', this.employee.cpf);
        formData.append('role_id', this.employee.role.id);
        formData.append('email', this.employee.email);
        formData.append('username', this.employee.username);
        formData.append('avatar', this.file);
        formData.append('marital_status', this.employee.marital_status);
        formData.append('cellphone', this.employee.cellphone);
        formData.append('phone', this.employee.phone);
        formData.append('schooling', this.employee.schooling);
        formData.append('birthday', this.birthDate);
        formData.append('gender', this.employee.gender);
        formData.append('rg', this.employee.rg);
        formData.append('registration_number', this.employee.registration_number);
        // Vamos verificar e enviar as unidades administrativas de acordo com a API esperada
        if (this.employee.administrative_unit && this.employee.administrative_unit.id) {
          // Primeiro, remover o administrative_unit_id do formData (caso tenha sido adicionado antes)
          // Isso não é possível diretamente com FormData, então adicionamos novamente com o valor correto
          formData.append('administrative_unit_id', this.employee.administrative_unit.id);
        } else {
          console.warn('Nenhuma unidade administrativa principal selecionada!');
        }

        // Array contendo apenas unidades secundárias (garantir que não tem a principal)
        const secondaryUnits = [];

        // Verifica se temos unidades administrativas para adicionar
        if (this.selectedAdministrativeUnits && this.selectedAdministrativeUnits.length > 0) {
          // Adicionar apenas as unidades que NÃO são a principal
          this.selectedAdministrativeUnits.forEach(unit => {
            if (this.employee.administrative_unit && unit.id !== this.employee.administrative_unit.id) {
              secondaryUnits.push(unit);
            }
          });
        }

        // Lógica para unidades administrativas secundárias
        const unitIds = secondaryUnits.map(unit => unit.id);

        // SEMPRE enviar administrative_unit_ids quando há mudanças nas unidades secundárias
        // Array vazio = remover todas as unidades secundárias
        // Array com IDs = definir essas unidades como secundárias
        formData.append('administrative_unit_ids', JSON.stringify(unitIds));


        formData.append('rescission_date', this.resignationDate);
        formData.append('admission_date', this.admissionDate);
        formData.append('super_admin', this.employee.super_admin);
        formData.append('can_generate_final_document', this.employee.can_generate_final_document);
        formData.append('can_end_process', this.employee.can_end_process);
        formData.append('permissions', this.employee.permissions);
        formData.append('address_attributes[number]', this.employee.address.number);
        formData.append('address_attributes[street]', this.employee.address.street);
        formData.append('address_attributes[complement]', this.employee.address.complement);
        formData.append('address_attributes[neighborhood]', this.employee.address.neighborhood);
        formData.append('address_attributes[city]', this.employee.address.city);
        formData.append('address_attributes[state]', this.employee.address.state);
        formData.append('address_attributes[zipcode]', this.employee.address.zipcode);
        formData.append('address_attributes[number]', this.employee.address.number);

        // Log para verificar os dados antes do envio
        for (let pair of formData.entries()) {
          console.log(pair[0] + ': ' + pair[1]);
        }

        this.isSaving = true;
        if (this.employee.id) {
          EmployeeService.update(formData, this.employee.id)
            .then(() => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'success',
                message: 'Funcionário atualizado com sucesso!',
                messageIcon: 'mdi-check',
              });
              this.closeDialog();
              this.$emit('updateList');
            }).catch((request) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              timeout: 6000,
              color: 'error',
              message: request.response.data.toString(),
              messageIcon: 'mdi-check',
            });
          }).finally(() => {
            this.isSaving = false;
          });
        } else {
          EmployeeService.create(formData)
            .then(({ data }) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'success',
                message: 'Funcionário criado com sucesso!',
                messageIcon: 'mdi-check',
              });
              this.closeDialog();
              this.$emit('updateList');
            }).catch((request) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              timeout: 6000,
              color: 'error',
              message: request.response.data.toString(),
              messageIcon: 'mdi-check',
            });
          }).finally(() => {
            this.isSaving = false;
          });
        }
      }
    },
    uploadFile(event) {
      this.file = event.target.files[0];
      this.previewImage();
    },
    removeAdminUnit(item) {
      const newSelection = this.selectedAdministrativeUnits.filter(unit => unit.id !== item.id);
      this.$set(this, 'selectedAdministrativeUnits', [...newSelection]);
    },
    previewImage() {
      if (this.file !== undefined) {
        const fr = new FileReader()
        fr.readAsDataURL(this.file)
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result;
        });
      } else {
        this.imageUrl = '';
      }
    },
    saveBirthDate(date) {
      this.$refs.menuBirthDate.save(date);
    },
    saveAdmissionDate(date) {
      this.$refs.menuAdmissionDate.save(date);
    },
    saveResignationDate(date) {
      this.$refs.menuResignationDate.save(date);
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    openFolderTransferDialog() {
      this.$refs.folderTransfer.open();
    }
  },
  computed: {
    formattedBirthDate() {
      this.formatDate(this.birthDate);
    },
    formattedAdmissionDate() {
      this.formatDate(this.admissionDate);
    },
    formattedResignationDate() {
      this.formatDate(this.resignationDate);
    },
    selectedEmployee() {
      return this.$store.getters.employee;
    },
    dialogTitle() {
      return (this.employee && this.employee.id) ? 'Editar Funcionário' : 'Novo Funcionário';
    },
    minResignationDate() {
      return this.admissionDate ? this.admissionDate : '1950-01-01';
    },
    administrativeUnitsFiltered() {
      // Filtrar unidades administrativas para não mostrar a unidade principal nas opções adicionais
      if (!this.employee.administrative_unit || !this.employee.administrative_unit.id) {
        return this.administrativeUnits;
      }
      return this.administrativeUnits.filter(unit => unit.id !== this.employee.administrative_unit.id);
    },
    selectedAdministrativeUnitsIds: {
      get() {
        return this.selectedAdministrativeUnits.map(unit => unit.id);
      },
      set(ids) {
        const units = this.administrativeUnits.filter(unit => ids.includes(unit.id));
        this.$set(this, 'selectedAdministrativeUnits', units);
      }
    }
  },
  watch: {
    menuBirthDate(val) {
      val && setTimeout(() => (this.$refs.birthDatePicker.activePicker = 'YEAR'));
    },
    birthDate(val) {
      this.birthDateFormatted = this.formatDate(val);
    },
    'employee.administrative_unit': function(newVal, oldVal) {
      // Quando o usuário muda o setor principal, atualizamos a lista filtrada
      if (newVal && newVal.id) {
        // Remover o setor principal da lista de setores adicionais se estiver lá
        const hadUnit = this.selectedAdministrativeUnits.some(unit => unit.id === newVal.id);


        // Usar Vue.set para garantir reatividade
        const filteredUnits = this.selectedAdministrativeUnits.filter(
          unit => unit.id !== newVal.id
        );
        this.$set(this, 'selectedAdministrativeUnits', [...filteredUnits]);

        // Não adicionar automaticamente o setor antigo como secundário
        // pois isso causa confusão para o usuário
      }
    },
    menuAdmissionDate(val) {
      val && setTimeout(() => (this.$refs.admissionDatePicker.activePicker = 'YEAR'));
    },
    admissionDate(val) {
      this.admissionDateFormatted = this.formatDate(val);
    },
    menuResignationDate(val) {
      val && setTimeout(() => (this.$refs.resignationDatePicker.activePicker = 'YEAR'));
    },
    resignationDate(val) {
      this.resignationDateFormatted = this.formatDate(val);
    },
    selectedEmployee: {
      handler: function(val) {
        this.employee = Object.assign({}, val);
        this.birthDate = this.employee.birthday || null;
        this.admissionDate = this.employee.admission_date || null;
        this.resignationDate = this.employee.rescission_date || null;
        // if (this.employee.role == null) {
        //   this.employee.role = {};
        // }
        // if (this.employee.administrative_unit == null) {
        //   this.employee.administrative_unit = {};
        // }
        if (this.employee.address == null) {
          this.employee.address = {};
        }

        // Carregar as unidades administrativas adicionais
        if (this.employee.administrative_units) {
          // Garantir que temos a unidade principal definida
          if (!this.employee.administrative_unit || !this.employee.administrative_unit.id) {
            console.warn('Unidade administrativa principal não definida!');
          }

          // Filtrar para não incluir a unidade principal nos setores adicionais
          const filteredUnits = this.employee.administrative_units
            .filter(unit => {
              // Só adicionar às unidades secundárias se não for a principal
              const isPrimary = this.employee.administrative_unit &&
                               unit.id === this.employee.administrative_unit.id;


              return !isPrimary;
            });

          // Usar Vue.set para garantir reatividade
          this.$set(this, 'selectedAdministrativeUnits', [...filteredUnits]);

        } else {
          this.$set(this, 'selectedAdministrativeUnits', []);
        }

        this.imageUrl = this.employee.avatar || '/static/images/settings/new-icons/user.svg';
        if(this.employee.id)
          this.validateForms();
        else
          this.resetForms();
      },
    },
  },
};
</script>

<style scoped>
.custom-uploader {
  cursor: pointer;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 99;
  opacity: 0;
  border: 18px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/employees/EmployeeForm.vue